import {gql} from '@apollo/client'

export const ADD_USER_DEDUCTION_TYPE = gql`
  mutation CommissionDeductionTypeCreate($input: commission_deduction_type_input!) {
    CommissionDeductionTypeCreate(input: $input) {
      commissionDeductionType {
        id
      }
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_USER_DEDUCTION_TYPE = gql`
  mutation CommissionDeductionTypeUpdate($id: ID!, $input: commission_deduction_type_input!) {
    CommissionDeductionTypeUpdate(input: $input, id: $id) {
      commissionDeductionType {
        id
      }
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_USER_DEDUCTION_TYPE = gql`
  mutation CommissionDeductionTypeDelete($id: ID!) {
    CommissionDeductionTypeDelete(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`
